export const UPDATE_PLAYER_DATA = 'UPDATE_PLAYER_DATA';
export const UPDATE_CURRENT_TRACK = 'UPDATE_CURRENT_TRACK';
export const UPDATE_CURRENT_STREAM_URL = 'UPDATE_CURRENT_STREAM_URL';
export const UPDATE_HISTORY = 'UPDATE_HISTORY';



// WEBPACK FOOTER //
// ./src/actions/action-types.js